import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsEditUsersResolverErrorStatesEnum {
    GetParentResolverDataFailed = ErrorStateScheduleEnum.PanelAccountsEditUsersResolverErrorStatesStartIndex,
    GetAssignedUsersFailed
}
